import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { BASE_URL } from '../../utils/constants';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import axios from 'axios';

const SignatureDialog = ({ open, onClose, onSave, id_paquete }) => {
    const sigCanvas = useRef({});
    const [isSaving, setIsSaving] = useState(false);

    const clear = () => sigCanvas.current.clear();

    const save = () => {
        setIsSaving(true);
        const canvas = sigCanvas.current.getTrimmedCanvas();
        const context = canvas.getContext('2d', { willReadFrequently: true });

        // Crear un nuevo canvas temporal para agregar un fondo blanco
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const tempContext = tempCanvas.getContext('2d');

        // Rellenar con color blanco
        tempContext.fillStyle = 'white';
        tempContext.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

        // Dibujar la firma encima del fondo blanco
        tempContext.drawImage(canvas, 0, 0);

        // Obtener el Data URL con el fondo blanco
        const dataUrl = tempCanvas.toDataURL('image/jpeg');
        const blob = dataURLToBlob(dataUrl);
        const formData = new FormData();
        formData.append('signature', blob, `${id_paquete}-firma.jpg`);

        axios.post(`${BASE_URL}/uploadSignature`, formData)
            .then((response) => {
                onSave(response.data.signaturePath);
                setIsSaving(false);
                onClose();
            })
            .catch((error) => {
                console.error("Error uploading signature:", error);
                setIsSaving(false);
            });
    };

    const dataURLToBlob = (dataURL) => {
        const parts = dataURL.split(';base64,');
        const byteString = atob(parts[1]);
        const mimeString = parts[0].split(':')[1];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Firma de Recepción</DialogTitle>
            <DialogContent>
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                />
                <Button onClick={clear} color="secondary">Limpiar</Button>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancelar</Button>
                <Button onClick={save} color="primary" disabled={isSaving}>
                    {isSaving ? 'Guardando...' : 'Guardar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SignatureDialog;